module.exports = __webpack_public_path__ + "img/base_activites_voile.10dbdca1.svg";